const COURSE_CODE_PATTERN = /\b[A-Z]{3,5}\s*\d{4}[A-Z]?\b/g;

export function getExcludedCourseCodes(data, courseCode) {
    const exclusion = data?.[courseCode]?.exclusion;
    if (!exclusion) return [];

    const availableCodes = new Set(Object.keys(data || {}).map(code => code.toUpperCase()));
    return [...new Set(
        (String(exclusion).toUpperCase().match(COURSE_CODE_PATTERN) || [])
            .map(code => code.replace(/\s/g, ''))
            .filter(code => availableCodes.has(code))
    )];
}

export function findCourseExclusionConflicts(data, timetable, candidateCode) {
    if (!data?.[candidateCode]) return [];

    const selectedCodes = Object.keys(timetable || {});
    const candidateExclusions = new Set(getExcludedCourseCodes(data, candidateCode));

    return selectedCodes.filter(selectedCode => (
        candidateExclusions.has(selectedCode)
        || getExcludedCourseCodes(data, selectedCode).includes(candidateCode)
    ));
}
